import { render, staticRenderFns } from "./GravarContaBancariaDialog.vue?vue&type=template&id=2bfa900b&"
import script from "./GravarContaBancariaDialog.vue?vue&type=script&lang=js&"
export * from "./GravarContaBancariaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports